// extracted by mini-css-extract-plugin
export default {"block":"ResetPassword_block__l7Wk7","link":"ResetPassword_link__ItQS2"};